import { render } from "./conversation.vue?vue&type=template&id=42133c59&scoped=true"
import script from "./conversation.vue?vue&type=script&lang=js"
export * from "./conversation.vue?vue&type=script&lang=js"

import "./conversation.vue?vue&type=style&index=0&id=42133c59&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42133c59"]])

export default __exports__